"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _UploadDropzone = _interopRequireDefault(require("./UploadDropzone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: theme.spacing(14),
    border: "1px solid",
    borderColor: theme.palette.divider
  }
}));

const ListUpload = (_ref) => {
  let children = _ref.children,
      onUpload = _ref.onUpload,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "onUpload"]);

  const classes = useStyles();
  return _react.default.createElement(_UploadDropzone.default, _extends({}, props, {
    onUpload: onUpload
  }), _react.default.createElement("div", {
    className: classes.root
  }, children));
};

var _default = ListUpload;
exports.default = _default;
module.exports = exports.default;